import { useState } from "react";
import { Progress, Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import PropTypes from "prop-types";

import { Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";

const Component = ({
	aspect = 1,
	onChange,
	section,
	value,
	noCrop = false,
}) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { progress } = state;

	const handleUpload = (options) => {
		const { file } = options;

		if (Types.uploadValidFormats.indexOf(file.type) >= 0) {
			if (file.size < parseInt(process.env.REACT_APP_IMAGE_SIZE_LIMIT)) {
				const formData = new FormData();

				formData.append("file", file);
				formData.append("section", section);

				API.upload("gallery", formData, (percent) => {
					setState((prevState) => ({ ...prevState, progress: percent }));
				})
					.then(({ data: { file, id } }) => {
						setState((prevState) => ({ ...prevState, progress: 0 }));

						onChange({ id, url: file });
					})
					.catch((error) => {});
			} else {
				message.error(Resources.uploadErros?.size);
			}
		} else {
			message.error(Resources.uploadErros?.extension);
		}
	};

	const uploadOpt = {
		//listType: 'picture-card',
		showUploadList: false,
		customRequest: handleUpload,
	};

	return noCrop ? (
		<Upload {...uploadOpt}>
			{progress > 0 ? (
				<>
					<span className="uploading">{Resources.upload}</span>
					<Progress percent={progress} showInfo={false} />
				</>
			) : !!value?.url ? (
				<img src={value.url} alt="avatar" className="image" />
			) : (
				<i className="fa fa-plus icon" />
			)}
		</Upload>
	) : (
		<ImgCrop aspect={aspect} rotate>
			<Upload {...uploadOpt}>
				{progress > 0 ? (
					<>
						<span className="uploading">{Resources.upload}</span>
						<Progress percent={progress} showInfo={false} />
					</>
				) : !!value?.url ? (
					<img src={value.url} alt="avatar" className="image" />
				) : (
					<i className="fa fa-plus icon" />
				)}
			</Upload>
		</ImgCrop>
	);
};

Component.propTypes = {
	aspect: PropTypes.number,
	onChange: PropTypes.func,
	section: PropTypes.string.isRequired,
	value: PropTypes.object,
};

export default Component;
